import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppBreadcrumbComponent } from './components/app-breadcrumb/app-breadcrumb.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DashboardCustomRangeDialogComponent } from './components/dashboard-custom-range-dialog/dashboard-custom-range-dialog.component';
import { DashboardTimePeriodSelectComponent } from './components/dashboard-time-period-select/dashboard-time-period-select.component';
import { FailedComponent } from './components/failed/failed.component';
import { LanguageSelectorComponent } from './components/language-selector/language-selector.component';
import { LoggedInAsPopupComponent } from './components/logged-in-as-popup/logged-in-as-popup.component';
import { LogoutButtonComponent } from './components/login-status-logout/logout-button.component';
import { MainNavComponent } from './components/main-nav/main-nav.component';
import { MenuListComponent } from './components/menu-list/menu-list.component';
import { MaterialModule } from '../modules/material.module';
import { HashtagModule } from '../hashtag/hashtag.module';
import { GlobalSearchComponent } from './components/global-search/global-search.component';
import { GlobalSearchResultComponent } from './components/global-search-result/global-search-result.component';
import { TenantIdListComponent } from './components/tenant-id-list/tenant-id-list.component';
import { MenuListRecursiveComponent } from './components/menu-list-recursive/menu-list-recursive.component';
import { DepartmentDropdownComponent } from './components/department-dropdown/department-dropdown.component';
import { AdminInnerNavComponent } from './components/admin-inner-nav/admin-inner-nav.component';
import { DocumentReadReceiptsDashboardModalComponent } from './components/document-read-receipts-dashboard-widget/document-read-receipts-dashboard-modal.component';
import { DocumentReadReceiptsDashboardWidgetComponent } from './components/document-read-receipts-dashboard-widget/document-read-receipts-dashboard-widget.component';
import { MaintenanceDashboardWidgetsComponent } from './components/maintenance-dashboard-widgets/maintenance-dashboard-widgets.component';
import { ReportsDashboardWidgetsComponent } from './components/reports-dashboard-widgets/reports-dashboard-widgets.component';
import { MainTableModule } from '../shared/main-table-module/main-table.module';
import { UIElementsModule } from '../shared/ui-elements/ui-elements.module';
import { AppLoaderDirective } from '../shared/directives/app-loader.directive';
import { MenuTreeModule } from '../shared/menu-tree-module/menu-tree.module';
import { ContainsPipe } from './pipes/contains.pipe';
import { BreadcrumbParsePipe } from './pipes/breadcrumb-parse.pipe';
import { TimeDisplayPipe } from './pipes/time-display.pipe';
import { PieChartComponent } from './components/pie-chart/pie-chart.component';
import { DepartmentSelectorMobileComponent } from './components/department-selector-mobile/department-selector-mobile.component';
import { UserProfileDropdownMobileComponent } from './components/user-profile-dropdown-mobile/user-profile-dropdown-mobile.component';
import { TextControlModule } from '../shared/text-control-module/text-control.module';
import { ResizeDirective } from '../shared/directives/resize.directive';
import { AppendDomainPipe } from '../shared/pipes/append-domain-name.pipe';
import { CheckPermissionPipe } from '../shared/pipes/check-permission.pipe';
import { DeviationsOverTimeComponent } from '../shared/dashboard/deviations-over-time/deviations-over-time.component';
import { DashboardListModalComponent } from '../shared/dashboard/deviations-over-time/dashboard-list-modal/dashboard-list-modal.component';
import { DialogContainerComponent } from '../shared/dialogs/dialog-container/dialog-container.component';
import { ConfirmDialogDirective } from '../shared/dialogs/confirm-dialog/confirm-dialog.directive';
import { FirstVisitHintComponent } from '../shared/components/first-visit-hint/first-visit-hint.component';
import { TrendIndicatorComponent } from '../shared/components/trend-indicator/trend-indicator.component';
import { SurveyBannerComponent } from './components/survey-banner/survey-banner.component';
import { DocumentEditLockToastComponent } from '../document-user/components/document-edit-lock-toast/document-edit-lock-toast.component';
import { DocumentWorkingCopyToastComponent } from '../document-user/components/document-working-copy-toast/document-working-copy-toast.component';
import { DocumentWorkingCopyDepartmentDialogComponent } from '../document-user/modals/document-working-copy-department-dialog/document-working-copy-department-dialog.component';
import { CartModalModule } from '../storage-user/modals/cart-modal/cart-modal.module';

@NgModule({
  declarations: [
    AdminInnerNavComponent,
    AppBreadcrumbComponent,
    DashboardComponent,
    DashboardCustomRangeDialogComponent,
    DashboardTimePeriodSelectComponent,
    DepartmentDropdownComponent,
    DepartmentSelectorMobileComponent,
    DocumentEditLockToastComponent,
    DocumentReadReceiptsDashboardModalComponent,
    DocumentReadReceiptsDashboardWidgetComponent,
    DocumentWorkingCopyDepartmentDialogComponent,
    DocumentWorkingCopyToastComponent,
    DeviationsOverTimeComponent,
    DashboardListModalComponent,
    FailedComponent,
    GlobalSearchComponent,
    GlobalSearchResultComponent,
    // JobsCriticalComponentsComponent, TODO Illia: uncomment this when we're ready to proceed with dashboard widgets
    LanguageSelectorComponent,
    LoggedInAsPopupComponent,
    LogoutButtonComponent,
    MainNavComponent,
    MaintenanceDashboardWidgetsComponent,
    MenuListComponent,
    // OpenReportsSectionComponent, TODO Illia: uncomment this when we're ready to proceed with dashboard widgets
    MenuListRecursiveComponent,
    PieChartComponent,
    ReportsDashboardWidgetsComponent,
    SurveyBannerComponent,
    TenantIdListComponent,
    UserProfileDropdownMobileComponent,
  ],
  imports: [
    AppendDomainPipe,
    AppLoaderDirective,
    CheckPermissionPipe,
    CommonModule,
    ConfirmDialogDirective,
    ContainsPipe,
    BreadcrumbParsePipe,
    CartModalModule,
    TimeDisplayPipe,
    DialogContainerComponent,
    FirstVisitHintComponent,
    HashtagModule,
    MainTableModule,
    MaterialModule,
    MenuTreeModule,
    ReactiveFormsModule,
    TextControlModule,
    ResizeDirective,
    RouterModule,
    TranslateModule,
    TrendIndicatorComponent,
    UIElementsModule,
  ],
  exports: [
    AppendDomainPipe,
    DashboardComponent,
    FailedComponent,
    LanguageSelectorComponent,
    LoggedInAsPopupComponent,
    LogoutButtonComponent,
    MainNavComponent,
    MenuListComponent,
    TextControlModule,
    MaterialModule,
  ],
})
export class CoreModule {}
